export default "__VITE_ASSET__DzbW9s9h__"